"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _elements = require("../../../styles/elements");

var _AllSelection = require("./AllSelection.styles");

/* eslint-disable react/jsx-no-bind */
var AllSelection = function AllSelection(_ref) {
  var className = _ref.className,
      selectedLength = _ref.selectedLength,
      allLength = _ref.allLength,
      type = _ref.type,
      toggleAllRowsSelected = _ref.toggleAllRowsSelected,
      isOnlyFirstPageAllRowsSelected = _ref.isOnlyFirstPageAllRowsSelected;
  var onClearSelectionClick = (0, _react.useCallback)(function () {
    toggleAllRowsSelected(false, 'ids');
  }, [toggleAllRowsSelected]);
  var onSelectAllClick = (0, _react.useCallback)(function () {
    toggleAllRowsSelected(true, 'all');
  }, [toggleAllRowsSelected]);
  var showContents = (0, _react.useMemo)(function () {
    if (allLength > 0 && selectedLength === allLength) {
      // Show this when all are selected
      return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [(0, _jsxRuntime.jsx)("span", {
          children: "All ".concat(selectedLength, " ").concat(type, " are selected.")
        }), (0, _jsxRuntime.jsx)("button", {
          type: "button",
          className: "grui",
          css: _elements.button.styles.link,
          onClick: onClearSelectionClick,
          children: "\xA0Clear selection"
        })]
      });
    }

    if (isOnlyFirstPageAllRowsSelected) {
      // Show this when only the rows in first page are selected and current page is 1
      return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [(0, _jsxRuntime.jsxs)("span", {
          children: ["All\xA0", (0, _jsxRuntime.jsx)("span", {
            css: _elements.text.styles.fontMedium,
            children: selectedLength
          }), "\xA0items on this page are selected."]
        }), (0, _jsxRuntime.jsxs)("button", {
          type: "button",
          className: "grui",
          css: _elements.button.styles.link,
          onClick: onSelectAllClick,
          children: ["\xA0", "Select all ".concat(allLength, " ").concat(type, " instead")]
        })]
      });
    }

    return null;
  }, [allLength, isOnlyFirstPageAllRowsSelected, onClearSelectionClick, onSelectAllClick, selectedLength, type]);
  return showContents && (0, _jsxRuntime.jsx)("div", {
    className: className,
    css: _AllSelection.styles.base,
    children: showContents
  });
};

AllSelection.propTypes = {
  className: _propTypes.string,
  selectedLength: _propTypes.number,
  allLength: _propTypes.number,
  type: _propTypes.string,

  /**
   * Callback for select all and clear selection
   * Function(bool)
   */
  toggleAllRowsSelected: _propTypes.func,
  isOnlyFirstPageAllRowsSelected: _propTypes.bool
};
AllSelection.defaultProps = {
  className: undefined,
  selectedLength: 0,
  allLength: 0,
  type: 'items',
  toggleAllRowsSelected: function toggleAllRowsSelected() {},
  isOnlyFirstPageAllRowsSelected: false
};
var _default = AllSelection;
exports["default"] = _default;
//# sourceMappingURL=AllSelection.js.map